const BLOCKED_CHARS_REGEX = /[./?@-]/g;

export const BLOCKED_NUMBER_KEYS = [".", "-", ",", "e", "E", "+"];

export const BLOCKED_CHARS_MESSAGE =
	"Os caracteres . / ? @ - não são permitidos e foram removidos.";

export function stripBlockedChars(value: string): string {
	return value.replace(BLOCKED_CHARS_REGEX, "");
}
